module.exports = __webpack_public_path__ + "d7f10c46c79930d3c85dfcd47ececfcb.png";